export default __webpack_public_path__ + "static/media/381.12d3931b.png";